module.exports = __webpack_public_path__ + "static/media/LogoCSIBServTra_def.fbe00ab0.png";